import { render, staticRenderFns } from "./symptomSurvey.vue?vue&type=template&id=10bff2c2"
import script from "./symptomSurvey.vue?vue&type=script&lang=js"
export * from "./symptomSurvey.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('10bff2c2')) {
      api.createRecord('10bff2c2', component.options)
    } else {
      api.reload('10bff2c2', component.options)
    }
    module.hot.accept("./symptomSurvey.vue?vue&type=template&id=10bff2c2", function () {
      api.rerender('10bff2c2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/hea/mss/symptomSurvey.vue"
export default component.exports